import ViewTemplate from './soil-veiw-template';
export default ViewTemplate;